<template>
  <div class="c-youtube shadow-md my-4 mx-2 md:mx-4 lg-mx-8">
    <iframe
      :src="src"
      title="YouTube video player"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowfullscreen
    />
  </div>
</template>

<script>
export default {
  name: 'CYoutube',
  props: {
    src: String
  }
}
</script>

<style lang="scss">
.c-youtube {
  iframe {
    width: 100%;
    height: 480px;
  }
}
</style>
